import { IntakeLabelCollection } from '../../entities/intake-label.interface';

export const AishAdditionalAssetsToolTips: IntakeLabelCollection = {
  vehicleDisability: {
    label: 'These assets may be exempt depending on your situation.',
    onBehalfLabel: `These assets may be exempt depending on <<oboName>>'s situation.`,
  },
};

export const AishAdditionalAssetsLabels: IntakeLabelCollection = {
  additionalAssetTypesIntro: {
    label: 'Fill in all asset types which apply to you.',
    spousePartnerLabel: `	Fill in all asset types which apply to you and your <<spouseLabel>>.`,
    onBehalfLabel: `Fill in all asset types which apply to <<oboName>>.`,
    onBehalfSpousePartnerLabel: `Fill in all asset types which apply to <<oboName>> and <<oboSpouseName>>.`,
  },
  applicantAdditionalAssetsColumn: {
    label: 'Personal',
    onBehalfLabel: `<<oboName>>`,
  },
  spouseAdditionalAssetsColumn: {
    label: '<<spouseLabelUpper>>',
    onBehalfSpousePartnerLabel: `<<oboSpouseName>>`,
  },
  applicantAdditionalAssetsDocuments: {
    label: 'Personal additional asset documents',
    onBehalfLabel: `<<oboName>>'s additional asset documents`,
  },
  spouseAdditionalAssetsDocuments: {
    label: '<<spouseLabelUpper>> additional asset documents',
    onBehalfSpousePartnerLabel: `<<oboSpouseName>>'s additional asset documents`,
  },
  hasVehicle: {
    label: 'Do you own a vehicle?',
    // replacementLabel: 'Do you or your <<replacementLabel>> own a vehicle?',
    spousePartnerLabel: 'Do you or your <<spouseLabel>> own a vehicle?',
    onBehalfLabel: `Does <<oboName>> own a vehicle?`,
    onBehalfSpousePartnerLabel: 'Does <<oboName>> or <<oboSpouseName>> own a vehicle?',
  },
  vehicleInformation: {
    label: 'Vehicle information (approximate value)',
    alternateLabel: 'Vehicle information',
  },
  hasRecreationalVehicle: {
    label: 'Do you own a recreational vehicle?',
    // replacementLabel: 'Do you or your <<replacementLabel>> own a recreational vehicle?',
    spousePartnerLabel: 'Do you or your <<spouseLabel>> own a recreational vehicle?',
    onBehalfLabel: `Does <<oboName>> own a recreational vehicle?`,
    onBehalfSpousePartnerLabel: 'Does <<oboName>> or <<oboSpouseName>> own a recreational vehicle?',
  },
  recreationalVehicleInformation: {
    label: 'Recreational vehicle information (approximate value)',
    alternateLabel: 'Recreational vehicle information',
  },
  hasProperty: {
    label: 'Do you own property?',
    // replacementLabel: 'Do you or your <<replacementLabel>> own property?',
    spousePartnerLabel: 'Do you or your <<spouseLabel>> own property?',
    onBehalfLabel: `Does <<oboName>> own property?`,
    onBehalfSpousePartnerLabel: 'Does <<oboName>> or <<oboSpouseName>> own property?',
  },
  propertyInformation: {
    label: 'Property information (approximate value)',
    alternateLabel: 'Property Information',
  },
  hasFarm: {
    label: 'Do you own a farm?',
    // replacementLabel: 'Do you or your <<replacementLabel>> own a farm?',
    spousePartnerLabel: 'Do you or your <<spouseLabel>> own a farm?',
    onBehalfLabel: `Does <<oboName>> own a farm?`,
    onBehalfSpousePartnerLabel: 'Does <<oboName>> or <<oboSpouseName>> own a farm?',
  },
  hasHomeQuarter: {
    label: 'Do you live on a home quarter section?',
    replacementLabel: 'Do you or your <<replacementLabel>> live on a home quarter section?',
    spousePartnerLabel: 'Do you or your <<spouseLabel>> live on a home quarter section?',
    onBehalfLabel: `Does <<oboName>> live on a home quarter section?`,
    onBehalfSpousePartnerLabel: 'Does <<oboName>> or <<oboSpouseName>> live on a home quarter section?',
  },
  farmInformation: {
    label: 'Farm information (approximate value)',
    alternateLabel: 'Farm',
  },
  hasBusiness: {
    label: 'Do you own a business?',
    // replacementLabel: 'Do you or your <<replacementLabel>> own a business?',
    spousePartnerLabel: 'Do you or your <<spouseLabel>> own a business?',
    onBehalfLabel: `Does <<oboName>> own a business?`,
    onBehalfSpousePartnerLabel: 'Does <<oboName>> or <<oboSpouseName>> own a business?',
  },
  businessInformation: {
    label: 'Business information (approximate value)',
    alternateLabel: 'Business',
  },
};
